@if (!error) {
  <div
    class="video-container-2"
    style="
display: flex;
    flex-direction: row;
    justify-content: center;
        border: 1px #0000002b solid;

"
    >
    <video
      [class.show]="!isCaptured"
      [class.hide]="isCaptured"
      #video
      id="video"
      [width]="WIDTH"
      [height]="HEIGHT"
      autoplay
    ></video>
    <canvas
      [class.show]="isCaptured && !imageCropper"
      [class.hide]="!isCaptured || imageCropper"
      #canvas
      id="canvas"
      [width]="WIDTH"
      [height]="HEIGHT"
    ></canvas>
  </div>
}
<div
    style="
display: flex;
    flex-direction: row;
    justify-content: center;

"
  >
  @if (activeImageCropper && imageCropper) {
    <lib-control-image-cropper
      [showBtnUplod]="isActiveCamera"
      [imageChangedEvent]="imageChangedEvent"
      [imageBase64]="imageBase64"
      (imageCroppedB64)="imageCropped($event)"
    ></lib-control-image-cropper>
  }
</div>
<div style="position: relative; height: 350px;width: 100%">
  <div class="snap-container">
    @if (!isCaptured) {
      <button
        class="btn btn-primary"
        [disabled]="!isActiveCamera"
        (click)="capture()"
        >
        <i class="material-icons"> local_see </i>
      </button>
    }
    @if (error) {
<div class="text-danger mt-4 " style="display: flex;
    justify-content: center;">
        <!--            {{ error }}. Please click refresh-->
        <div style="text-align: left;color: red;margin: 10px;max-width: 500px">
          @if (error && translate.currentLang === 'fr') {
            L'accès à la caméra a été bloqué.<br>
            Le navigateur n'a pas accès à votre caméra pour prendre une photo.
            Veuillez svp cliquer le bouton  <span style="color: black;font-size: 15px;font-weight: bold">{{'uploadImage.uploadFile' | translate}}</span>
            pour télécharger une photo existante.
          }
          @if (error && translate.currentLang !== 'fr') {
            Camera access has been blocked.<br>
            The browser does not have access to your camera to take a picture.
            Please click the  <span style="color: black;font-size: 15px;font-weight: bold">{{'uploadImage.uploadFile' | translate}}</span> button to upload an existing photo.
          }
        </div>
        <br/>
        <!--            <a-->
        <!--                href="https://support.google.com/chrome/answer/2693767?hl=fr&co=GENIE.Platform%3DDesktop"-->
        <!--                target="blank"-->
        <!--            >-->
        <!--                Cliquez ici pour plus d'information-->
      <!--            </a>-->
      <!--            <br/>-->
      <!--            <a-->
      <!--                href="https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DDesktop"-->
      <!--                target="blank"-->
      <!--            >-->
      <!--                Click here for more information-->
    <!--            </a>-->
  </div>
}

<div class="file-field input-field" >
  <div class="btn">
    <span> <mat-icon>file_upload</mat-icon>    {{'uploadImage.uploadFile' | translate}}</span>
    <input
      type="file"

      (change)="fileChangeEvent($event)"
      />
  </div>
</div>
<div style="display: flex;   flex-direction: row;justify-content: center">

  @if (isCaptured) {
    <button class="btn btn-danger" (click)="removeCurrent()">
      {{'uploadImage.takeAnother' | translate}}
    </button>
  }
  <div style="width: 10px;"></div>
  @if (isCaptured) {
    <button class="btn btnOk" (click)="validCapture()">
      {{'uploadImage.validSelection' | translate}}
    </button>
  }
</div>

</div>
</div>


@if (maxCaptures>1) {
  <ul class="list-unstyled">
    @for (src of captures; track src; let idx = $index) {
      <li (click)="setPhoto(idx)">
        <img [src]="src" height="50"/>
      </li>
    }
  </ul>
}

